/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 템플릿 필드 클래스를 정의한다.
 *
 * @file /src/components/form/field/template/Template.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 10. 5.
 */
import * as parent from '@components/form/field/theme/Theme';
import { Field } from '../Field';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T> extends parent.Properties<T> {
    /**
     * 템플릿목록을 불러올 URL
     */
    url: string;

    /**
     * 템플릿 소유자
     */
    owner: { type: string; name: string };

    /**
     * 템플릿을 사용할 컨텍스트명 (컨텍스트 설정을 위한 템플릿인 경우)
     */
    context?: string;

    /**
     * 이벤트리스너
     */
    listeners?: Listeners<T>;
}

export class Template extends parent.Theme {
    /**
     * 기본 URL
     */
    static url: string = null;

    /**
     * 컴포넌트 확장타입
     */
    variant = 'template';

    /**
     * 템플릿 소유자
     */
    owner: { type: string; name: string };

    /**
     * 템플릿을 사용할 컨텍스트명
     */
    context: string;

    /**
     * Display 필드 클래스를 정의한다.
     *
     * @param properties - 초기설정
     */
    constructor(public properties: Properties<Template> = null) {
        super(properties);

        this.url = properties.url ?? Template.url ?? '/';
        this.owner = properties.owner;
        this.context = properties.context ?? null;
        this.getSelect().getStore().getProvider().setParam('type', this.owner.type);
        this.getSelect().getStore().getProvider().setParam('name', this.owner.name);
        if (this.context !== null) {
            this.getSelect().getStore().getProvider().setParam('context', this.context);
        }
    }

    /**
     * 기본 URL 을 설정한다.
     *
     * @param url - 기본 URL
     */
    static setUrl(url: string): void {
        Template.url = url;
    }

    /**
     * 필드설정을 이용하여 필드를 가져온다.
     *
     * @param config - 환경설정
     * @returns 환경설정 필드
     */
    async getConfigFields(config: { [key: string]: any }[]): Promise<Field[]> {
        const fields: Field[] = [];
        for (const item of config) {
            let field: Field = null;
            switch (item.type) {
                case 'template':
                    field = new Template({
                        name: item.name,
                        label: item.label ?? 'UNKNOWN',
                        value: item.value,
                        url: this.url,
                        owner: {
                            type: item.package.type,
                            name: item.package.name,
                        },
                    });
                    break;

                default:
                    field = (await super.getConfigFields([item])).at(0) ?? null;
            }

            if (field !== null) {
                fields.push(field);
            }
        }

        return fields;
    }
}
